<template>
  <div class="tideng_3rd_layout">
    <!-- 活动标题 -->
    <div v-wechat-title="'一亿钻石 暴击赠送'"></div>
    <!-- 首页进入青瓷游戏LOGO -->
    <transition enter-active-class='animated fadeIn' leave-active-class='animated fadeOut' name='fade'>
      <div @touchmove.prevent class='preloading preloading-tideng' v-show='preloadingShow'></div>
    </transition>
    <!-- 登录弹窗 -->


    <Login v-if='isShowLogin' v-on:channelCallback='selectCallback' @loginSuccess="loginSuccess" :gameName="gameName"
      :downloadUrl="downloadUrl" :loginTypes="loginTypes" channelTips="角色UID可在游戏中—设置—UID查看" :autoOpenOS="false"
      noAuthLogin></Login>
    <Os v-if='isShowOs' v-on:selectCallback='selectCallback' v-on:logoutCallback='osCancell'
      @getSelectInfo='getSelectInfo' :gameName="gameName"></Os>
    <Header v-if='true' :config='headerConfig' :isShowInfo='true' :isOnline='1' @reInit="reInit"
      @onOfficial="onOfficial" />

    <div :class="'super_punch_clock_page ' + (isSafari ? 'safari' : '')">
      <div class="index">
        <div class="main_01">
          <div class="main_01_title"></div>
        </div>
        <div class="main_02">
          <div class="slogan"></div>
          <div class="main_02_title"></div>
          <div class="main_02_price"></div>
          <div class="main_02_btn" @click="!disabled && setReward(1)"></div>
          <div class="main_02_text"> 2月29日上线后开放领取</div>
        </div>
        <div class="main_03">


          <div :class="isPC ? 'main_03_detail_pc main_03_detail ' : 'main_03_detail'"
            @click="!disabled && openPopup('ruleShow')"></div>
          <div class="main_03_title"></div>
          <div :class="['diamond', { 'active': diamond_active }]">
            <div class="diamond_btn" @click="!disabled && setReward(2)"></div>
            <div class="diamond_text text_left">{{ activity.remain_number }}
              <div class="diamond_text_active">+{{ diamond_active_text }}</div>
            </div>
            <div class="diamond_text text_right">{{ activity.total_number }}
              <div class="diamond_text_active">+{{ diamond_active_text }}</div>
            </div>
          </div>
          <SlotMachine class="slotMachine" :trigger="trigger" :configs="configs" :activity="activity"
            :shareLink="shareLink" :taksInfo="activity.task_info" @doTask="doTask" @getReward="getReward"
            @lottery="lottery" @bubbling="bubbling" @disabled='changeDisabled' />
        </div>
        <div class="main_04">
          <div class="main_04_title">
          </div>
          <div class="main_04_content">

            <div class="main_04_content_item live">
              <div class="main_04_content_item_btn" @click="goLink('https://v.douyin.com/iNag9Jpa/')">
              </div>
            </div>

            <!-- <div class="main_04_content_item pay">
              <div class="main_04_content_item_btn">
              </div>
            </div> -->

            <div class="main_04_content_item sign">
              <div class="main_04_content_item_btn"
                @click="goLink('https://www.taptap.cn/events/game-sign/cuymtezx?utm_medium=rep&utm_source=rep_lv97bl4rzmg_h5url1225')">
              </div>
            </div>

            <div class="main_04_content_item turntable" @click="turntableShow = true">
            </div>
          </div>
          <div class="main_04_bottom"></div>
        </div>
      </div>
      <div class="foot-page">
        <Footer :gameName="gameName" />
      </div>

      <!-- 领取弹窗 -->
      <div class="reward_wrap popup_wrap" v-show="getShow" @click="!disabled && closePopup('getShow')">
        <transition enter-active-class="animated fadeIn" leave-active-class="animated fade-leave-active"
          :duration="{ enter: 1000 }">
          <div class="detail_box">
            <div class="btn_box">
              <div class="cancel_btn" @click=" closePopup('getShow')"></div>
              <div class="sure_btn" @click=" reward()"></div>
            </div>
          </div>
        </transition>
      </div>

      <!-- 转盘展示 -->
      <div class="turntable_wrap popup_wrap" v-show="turntableShow" @click="closePopup('turntableShow')">
        <transition enter-active-class="animated fadeIn" leave-active-class="animated fade-leave-active"
          :duration="{ enter: 1000 }">
          <div class="detail_box">
            <div class="detail">
              <img class="swiper-lazy" src="https://download4.qcplay.com/h5-images/active/tideng/third/part/turntable.png" alt="详情">
            </div>
            <div class="close_btn" @click="closePopup('turntableShow')"></div>
          </div>
        </transition>
      </div>

      <!-- 助力弹窗 -->
      <div class="help_wrap popup_wrap" v-show="helpShow" @click="!disabled && closePopup('helpShow')">
        <transition enter-active-class="animated fadeIn" leave-active-class="animated fade-leave-active"
          :duration="{ enter: 1000 }">
          <div class="detail_box">
            <div class="help_text">
              <p>好友{{ help_account }}请求你的帮助</p>
              <p>点击确认完成助力</p>
            </div>
            <div class="help_btn" @click=" help()"></div>
            <div class="close_btn" @click="closePopup('helpShow')"></div>
          </div>
        </transition>
      </div>

    </div>


    <!-- 跳转弹窗 -->
    <div class="go_wrap popup_wrap" v-show="goShow" @click="closePopup('goShow')">
      <transition enter-active-class="animated fadeIn" leave-active-class="animated fade-leave-active"
        :duration="{ enter: 1000 }">
        <div class="detail_box">
          <div class="btn_box">
            <div class="sure_btn"
              @click="windowOpenLink('https://l.taptap.cn/hUcIuKNS?channel=rep-rep_io8p76gwjif_h5url1223')">
            </div>
          </div>
        </div>
      </transition>
    </div>


    <!-- 规则弹窗 -->
    <div class="rule_wrap popup_wrap" v-show="ruleShow" @click="closePopup('ruleShow')">
      <transition enter-active-class="animated fadeIn" leave-active-class="animated fade-leave-active"
        :duration="{ enter: 1000 }">
        <div class="detail_box">
          <div class="detail">
            <img class="swiper-lazy" src="https://download4.qcplay.com/h5-images/active/tideng/third/part/rule.png" alt="详情">
          </div>
          <div class="close_btn" @click="closePopup('ruleShow')"></div>
        </div>
      </transition>
    </div>

    <!-- 更多 -->
    <div class="rule_wrap popup_wrap" v-show="moreShow" @click="closePopup('moreShow')">
      <transition enter-active-class="animated fadeIn" leave-active-class="animated fade-leave-active"
        :duration="{ enter: 1000 }">
        <div class="detail_box">
          <div class="detail">
            <img class="swiper-lazy" src="https://download4.qcplay.com/h5-images/active/tideng/third/part/more.png" alt="详情">
          </div>
          <div class="close_btn" @click="closePopup('moreShow')"></div>
        </div>
      </transition>
    </div>

    <!-- 禁止 -->
    <div class="rule_wrap popup_wrap" v-show="banShow" @click="closePopup('banShow')">
      <transition enter-active-class="animated fadeIn" leave-active-class="animated fade-leave-active"
        :duration="{ enter: 1000 }">
        <div class="detail_box">
          <div class="detail">
            <img class="swiper-lazy" src="https://download4.qcplay.com/h5-images/active/tideng/third/part/ban.png" alt="详情">
          </div>
          <div class="close_btn" @click="closePopup('banShow')"></div>
        </div>
      </transition>
    </div>

    <!-- 微信下载 -->
    <div class="wx_download_wrap popup_wrap" v-show="wxLoadShow">
      <transition enter-active-class="animated fadeIn" leave-active-class="animated fade-leave-active"
        :duration="{ enter: 1000 }">
        <div class="wx_download_wrap_content" @click="closePopup('wxLoadShow')"></div>
      </transition>
      <div class="close-bg" v-if="wxLoadShow" @click="closePopup('wxLoadShow')"></div>
    </div>
    <!-- 全局遮罩 -->
    <div :class="'prevent-wrap prevent-wrap-' + preventShow"></div>
  </div>
</template>
<script>
import { Toast } from 'mint-ui';
import { mapState, mapMutations, mapActions } from 'vuex';
import Os from '@/components/os';
import Login from '@/components/login';
import Header from '../components/Header';
import { headerConfig } from '../headerConfig';
import { onGetInitDataAPI, reward, lottery, taskReward, doTaskThree, onGetInitHelpDataAPI, help } from '../api';
import { getRandomString, buriedLogger, wechatBrowser } from '@/utils/utils';
import SlotMachine from '../components/SlotMachine/SlotMachine.vue';
import Footer from "@/components/Footer";
import Clipboard from 'clipboard';

export default {
  name: 'demo',
  components: {
    Header,
    Login,
    Os,
    SlotMachine,
    Footer
  },
  data() {
    return {
      headerConfig,
      gameName: 'tideng',
      downloadUrl: 'https://tideng.qingcigame.com/',
      loginTypes: ["sms", "password"],
      preloadingShow: true,
      titleShow: true,
      preventShow: false,
      logger: null,
      isWechatBrowser: false, // 是否为微信浏览器
      isSafari: false,
      shareLink: null,
      activity: {
        "times": 0,
        "is_login": false,
        "is_today_exchange": false,
        "is_task_start": false,
        "is_rewards_start": false,
        "is_has_number": false,
        "task_info": [
          {
            "id": 1,
            "title": "每日完成1次游戏登录",
            "dice": 1,
            "_get": false,
            "is_get": false
          },
          {
            "id": 2,
            "title": "每日完成1次页面分享",
            "dice": 1,
            "_get": false,
            "is_get": false
          },
          {
            "id": 3,
            "title": "每次前往论坛发帖1次",
            "dice": 1,
            "_get": false,
            "is_get": false
          }
        ],
        "total_number": 0,
        "remain_number": 0,
        "reward_get": false
      },
      configs: [
        {
          style: 'gift-style',
          gifts: Array.from(new Array(10), (val, index) => { return { type: 'image', path: require(`@/assets/images/active/tideng/third/03/num/${index}.png`), name: index } }),
          duration: 4000,
          fontSize: 150,
          width: 114,
          height: 180,
          randomDeg: Math.random()

        },
        {
          style: 'gift-style',
          gifts: Array.from(new Array(10), (val, index) => { return { type: 'image', path: require(`@/assets/images/active/tideng/third/03/num/${index}.png`), name: index } }),
          duration: 5000,
          fontSize: 150,
          width: 114,
          height: 180,
          randomDeg: Math.random()
        },
        {
          style: 'gift-style',
          gifts: Array.from(new Array(10), (val, index) => { return { type: 'image', path: require(`@/assets/images/active/tideng/third/03/num/${index}.png`), name: index } }),
          duration: 6000,
          fontSize: 150,
          width: 114,
          height: 180,
          randomDeg: Math.random()
        }
      ],
      diamond_active: false,
      diamond_active_text: 200,
      trigger: null,
      clearTrigger: null,
      ruleShow: false,
      goShow: false,
      goInt: null,
      banShow: false,
      moreShow: false,
      helpShow: false,
      turntableShow: false,
      helpSign: false,
      helpCode: null,
      help_account: null,
      isPC: false,
      wxLoadShow: false,
      disabled: false,
      rewardType: null,
      objUserInfo: {},
      getShow: false,
      rewardType: false,
      loopInt: null,
      task_type: null,
    };
  },
  created() {
    // 清空store上的用户数据
    this.setInitActiveInfo();
    this.setInitUserInfo();

    this.isWechatBrowser = wechatBrowser();
    if (this.isWechatBrowser) { // 在微信app下

    } else {
      // safari下底部被遮住
      if ((/Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent))) {
        this.isSafari = true;
      }
    }

    // 埋点
    const bl = buriedLogger('tideng', '提灯三周年庆典');
    this.logger = bl;

    const reload = () => {
      const { protocol, host } = window.location;
      const link = `${protocol}//${host}/tideng/third/enter${getRandomString()}`;
      setTimeout(() => {
        window.location.href = `${link}?referer=game`;
      }, 200);
    };

    var userAgent = navigator.userAgent.toLowerCase();
    this.isPC = userAgent.indexOf('windows') > -1 || userAgent.indexOf('macintosh') > -1;

    if (this.isPC) {
      this.$router.push('pc');
      console.log(this.isPC, '当前设备是 PC');
    } else {
      console.log('当前设备不是 PC');
    }
    // reload();
    if (localStorage.getItem('objUserInfo') === null) {
    } else {
      this.objUserInfo = JSON.parse(localStorage.getItem('objUserInfo'));
    }
    this.getUserInfo();
    this.preloadingShow = false;

    this.isSetShare();
  },
  mounted() {
  },

  computed: {
    ...mapState([
      'userInfo',
      'activeInfo',
      'isShowLogin',
      'isShowOs'
    ])
  },
  watch: {
    userInfo: {
      handler(newValue, oldValue) {
        console.log('oldValue------>', oldValue)
        console.log('newValue------>', newValue)
        if (oldValue.account) {
          if (newValue.account !== oldValue.account) {
            if (!newValue.account) {
              // TAG: 注销的时候
              // this.clearActiveInfo();
              this.reInit()
            } else {
              console.log('登录成功')
              this.getUserInfo()
            }
          }
        }
      }
    }
  },
  methods: {
    setReward(type) {
      function throttle(func, delay) {
        let timeoutId;
        return function () {
          if (!timeoutId) {
            timeoutId = setTimeout(() => {
              func.apply(this, arguments);
              timeoutId = null;
            }, delay);
          }
        };
      }
      if (!this.userInfo.account) {
        console.log('请先登录')
        this.changeLoginPopup(true)
        return this.onToast('很抱歉，请先登录');
      }

      if (!this.activity.is_rewards_start) return this.onToast('未到领奖时间，需等待2月29日游戏上线后领取')

      if (this.is_today_exchange) {
        return this.onToast('很抱歉,您今天已经兑换过奖励，请明日来抽奖!')
      }

      if (!this.userInfo.hasOwnProperty('role_id')) {
        console.log('选择角色')
        this.rewardType = type
        throttle(this.changeOsPopup(true), 1000)
        return
      } else if (!this.userInfo.role_id) {
        console.log('选择角色')
        this.rewardType = type
        throttle(this.changeOsPopup(true), 1000)
        return
      }
      this.rewardType = type
      if (type == 1) {
        return this.reward()
      }
      if (!this.activity.is_today_exchange) {
        return this.getShow = true
      } else {
        return this.onToast('很抱歉,您今天已经兑换过奖励!')
      }
    },
    goLink(url) {
      window.location.href = url;
    },
    windowOpenLink(url) {
      clearTimeout(this.goInt)
      window.open(url)
    },
    changeDisabled(val) {
      if (val == 1) {
        this.disabled = true
      } else {
        this.disabled = false
      }
    },
    // 领取奖励
    reward() {
      const type = this.rewardType;
      const params = {
        type: type
      }
      reward(params).then(res => {
        if (res.code === 200) {
          this.onToast('领取成功');
          this.getUserInfo();
        } else {
          this.onToast(res.message);
        }
      })
    },
    // 任务
    doTask(item) {
      console.log(item)
      const that = this
      if (!this.userInfo.account) {
        console.log('请先登录')
        this.changeLoginPopup(true)
        return this.onToast('很抱歉，请先登录');
      }
      if (item === 1) {
        this.onToast('登录游戏即可完成任务！');
        return
      }
      if (item === 3) {
        this.doTaskThree()
        if (!this.activity.task_info[2]._get) {
          document.onvisibilitychange = function () {
            if (document.visibilityState == 'visible') {
              that.logger.sum('提灯与地下城_三周年,任务三跳转论坛');
              console.log('切回应用');
              that.getUserInfo()
              that.loopInt = setInterval(function () {
                console.log('检测是否返回应用');
                that.getUserInfo()
              }, 1000)
              setTimeout(function () {
                console.log('清除定时器');
                clearInterval(that.loopInt)
              }, 6000)
            }
          };
        }
        this.goShow = true
        this.goInt = setTimeout(function () {
          window.open('https://l.taptap.cn/hUcIuKNS?channel=rep-rep_io8p76gwjif_h5url1223')
        }, 3000)
        // window.location.href = 'https://l.taptap.cn/hUcIuKNS?channel=rep-rep_io8p76gwjif_h5url1223'
        return
      }

      if (item === 2) {
        this.task_type = item
        return this.onCopy(item)
      }
    },
    // 领取任务
    getReward(item) {
      if (!this.userInfo.account) {
        console.log('请先登录')
        this.changeLoginPopup(true)
        return this.onToast('很抱歉，请先登录');
      }
      const params = {
        task_id: item,
      }
      taskReward(params).then(res => {
        if (res.code === 200) {
          this.logger.sum(`提灯与地下城_三周年,领取奖励${item}`);
          this.onToast('领取成功');
          this.getUserInfo();
        } else {
          this.onToast(res.message);
        }
      })
    },
    lottery() {
      // const randomDegs = [Math.floor(Math.random() * 10), Math.floor(Math.random() * 10), Math.floor(Math.random() * 10)];
      // randomDegs.forEach((element, index) => {
      //   this.configs[index].randomDeg = element * 1
      // });
      // this.$set(this, 'configs', this.configs)
      // this.trigger = new Date()
      // console.log(randomDegs, 'randomDegs')


      if (!this.userInfo.account) {
        console.log('请先登录')
        this.changeLoginPopup(true)
        return this.onToast('很抱歉，请先登录');
      }
      lottery().then(res => {
        if (res.code === 200) {
          this.logger.sum('提灯与地下城_三周年,参与抽奖');
          this.diamond_active_text = JSON.parse(JSON.stringify(res.data.number)) * 1 * 10
          let randomDeg = JSON.parse(JSON.stringify(res.data.number)).toString()
          const randomDegs = randomDeg.split('')

          if (randomDegs.length < 2) {
            randomDegs.unshift('0')
            randomDegs.unshift('0')
          }
          if (randomDegs.length < 3) {
            randomDegs.unshift('0')
          }
          randomDegs.forEach((element, index) => {
            this.configs[index].randomDeg = element * 1
          });
          this.$set(this, 'configs', this.configs)
          this.trigger = new Date()
          this.activity.times = this.activity.times - 1
          this.getUserInfo()
        } else {
          this.onToast(res.message);
        }
      })
    },
    activeText() {
      this.diamond_active = true
      setTimeout(() => {
        this.diamond_active = false
        this.activity.remain_number = this.activity.remain_number * 1 + this.diamond_active_text * 1
        this.activity.total_number = this.activity.total_number * 1 + this.diamond_active_text * 1
      }, 1000)
    },
    bubbling(key) {
      if (key.indexOf('Show') !== -1) {
        return this[key] = true
      }
    },
    onOfficial() {
      this.isWechatBrowser = wechatBrowser();
      if (this.isWechatBrowser) { // 在微信app下
        console.log('在微信app下');
        return this.wxLoadShow = true
      }
      this.logger.sum('提灯与地下城_三周年,前往下载');
    },
    // 复制链接
    onCopy(item) {
      const my_id = '#my-code'
      const that = this
      if (!that.userInfo.account) {
        console.log('请先登录')
        that.changeLoginPopup(true)
        return that.onToast('很抱歉，请先登录');
      }
      const clipboard = new Clipboard(my_id);
      console.log(clipboard, 'clipboard')
      clipboard.on('success', (e) => {
        console.log(item, 'clipboard')
        if (!that.task_type) return
        that.logger.sum('提灯与地下城_三周年,复制链接邀请好友');
        that.onToast('邀请链接复制成功，快快发送给你的好友吧~');
        that.task_type = null
        e.clearSelection();
      });
      clipboard.on('error', (e) => {
        console.log(clipboard, 'error')
        that.onToast('复制失败');
      });
    },
    // 产生任务3访问论坛奖励
    doTaskThree() {
      const that = this
      const params = {
        task_id: 3
      }
      doTaskThree(params).then(response => {
        if (response.code === 200) {
        } else {
          that.onToast(response.message);
        }
      })
    },
    // 助力
    help() {
      const that = this
      that.helpCode = that.$route.query.code
      const params = {
        helper_id: that.helpCode
      }
      help(params).then(response => { 
        if (response.code === 200) {
          that.logger.sum('提灯与地下城_三周年,好友完成助力');
          that.onToast(response.message);
        } else {
          that.onToast(response.message);
        }
      })
    },
    // 帮助页初始化
    onGetInitHelpDataAPI() {
      const that = this
      that.helpCode = that.$route.query.code
      const params = {
        helper_id: that.helpCode
      }
      onGetInitHelpDataAPI(params).then(response => {
        if (response.code === 200) {
          this.help_account = response.data.help_account
          that.helpShow = true
          that.helpSign = true
        } else {
          that.onToast(response.message);
        }
      })
    },
    // 获取用户信息
    async getUserInfo() {
      const that = this
      await onGetInitDataAPI().then(response => {
        that.preloadingShow = false;
        if (response.code === 200) {
          if (!this.userInfo.role_id) {
            that.onInitState(response);
          }
          that.initShareData();
          that.activity = response.data.activity
          if (that.$route.fullPath.indexOf('help') > -1 && that.helpSign === false) {
            that.helpCode = that.$route.query.code
            this.logger.sum('提灯与地下城_三周年,好友加入助力');
            if (!that.userInfo.account) {
              console.log('请先登录')
              that.changeLoginPopup(true)
              return
            }
            that.onGetInitHelpDataAPI();
          }

          if (that.loopInt && response.data.activity.task_info[2]._get) {
            console.log('清除定时器')
            clearInterval(that.loopInt)
          }

          // 例如：获取好友助力信息等
        } else {
          that.onToast(response.message);
          that.setInitUserInfo();
          that.setInitActiveInfo();
        }
      }).catch(() => {
        that.preloadingShow = false;
      }).finally(() => {
      })
    },
    onInitState(response) {
      const { code } = response || {}
      if (response.code == 200) {
        console.log('初始化数据成功');
        if (this.objUserInfo.account === response.data.userinfo.account) {
          this.setUserInfo(this.objUserInfo);
          console.log(this.userInfo, '用户账号一致,初始化数据成功');
        } else {
          this.setUserInfo(response.data.userinfo);
        }
      }
      // 很抱歉，请先登录！
      if (response.code == 403) {
        this.changeLoginPopup(true);
      }
    },
    initShareData() {
      try {
        const { protocol, host } = window.location;
        this.shareLink = `${protocol}//${host}/tideng/third/help${getRandomString()}?code=` + this.userInfo.user_id;
        this.$set(this, 'shareLink', this.shareLink)
        console.log('shareLink', this.shareLink);
        this.isSetShare(this.shareLink);
        // 例如：获取好友助力信息等
      } catch (err) {
        // 错误信息
        console.log('err', err);
      }
    },
    // 清除data里面相关数据
    clearActiveInfo() {
      this.configs = [
        {
          style: 'gift-style',
          gifts: Array.from(new Array(10), (val, index) => { return { type: 'image', path: require(`@/assets/images/active/tideng/third/03/num/${index}.png`), name: index } }),
          duration: 4000,
          fontSize: 150,
          width: 114,
          height: 180,
          randomDeg: 0
        },
        {
          style: 'gift-style',
          gifts: Array.from(new Array(10), (val, index) => { return { type: 'image', path: require(`@/assets/images/active/tideng/third/03/num/${index}.png`), name: index } }),
          duration: 5000,
          fontSize: 150,
          width: 114,
          height: 180,
          randomDeg: 0
        },
        {
          style: 'gift-style',
          gifts: Array.from(new Array(10), (val, index) => { return { type: 'image', path: require(`@/assets/images/active/tideng/third/03/num/${index}.png`), name: index } }),
          duration: 6000,
          fontSize: 150,
          width: 114,
          height: 180,
          randomDeg: 0
        }
      ]
      this.activity = {
        "times": 0,
        "is_login": false,
        "is_today_exchange": false,
        "is_task_start": false,
        "is_has_number": false,
        "task_info": [
          {
            "id": 1,
            "title": "每日完成1次游戏登录",
            "dice": 1,
            "_get": false,
            "is_get": false
          },
          {
            "id": 2,
            "title": "每日完成1次页面分享",
            "dice": 1,
            "_get": false,
            "is_get": false
          },
          {
            "id": 3,
            "title": "每次前往论坛发帖1次",
            "dice": 1,
            "_get": false,
            "is_get": false
          }
        ],
        "total_number": 0,
        "remain_number": 0,
        "reward_get": false
      },

        this.helpSign = false
      this.rewardType = null
      this.$set(this, 'configs', this.configs)
      this.$set(this, 'activity', this.activity)
      this.trigger = new Date()
      this.setInitUserInfo();
      this.setInitActiveInfo();
      localStorage.removeItem('objUserInfo');
      console.log(this.userInfo, '注销')
    },
    // 选择角色后
    selectCallback() {
      // 初始化
      if (this.rewardType) {
        this.setReward(this.rewardType)
        this.rewardType = null
      }
    },
    closePopup(name) {
      this[name] = false;
    },
    openPopup(name) {
      this[name] = true;
    },
    getSelectInfo(selectInfo) {
      this.selectInfo = selectInfo
      selectInfo.account = this.userInfo.account
      selectInfo.user_id = this.userInfo.user_id
      this.setUserInfo(selectInfo);
      console.log(this.userInfo, '选择角色后')

      let objUserInfo = JSON.stringify(selectInfo);
      // 存储到 localStorage
      localStorage.setItem('objUserInfo', objUserInfo);
    },
    loginSuccess() {
      console.log('登录成功')
      this.getUserInfo()
    },
    reInit() {
      console.log('清除data里面相关数据')
      this.clearActiveInfo(); // 清除data里面相关数据
    },
    // 区组弹窗注销-相关参数复位
    osCancell() { },
    // TAG: 其他简易封装的方法
    onToast(config) {
      const curConfig = {
        duration: 1000,
        className: 'toasts'
      };
      if (!config) {
        console.error('缺少config参数');
        return false;
      }
      if (typeof config === 'string') {
        curConfig.message = config;
      }
      Toast(curConfig);
    },
    // 微信分享
    isSetShare() {
      this.setShare({
        link: `https://h5.qingcigame.com/tideng/third/enter${getRandomString()}`,
        title: '《提灯与地下城 重制版》1亿钻石暴击赠送中',
        imgUrl: 'https://download4.qcplay.com/qcgame-api/MBNcX28WGgKfce8RNaOp7XvFsz8rcTvPYi2Q8Vz7.png',
        desc: '超高爆率，一锤定音！海量钻石，等你来领~'
      })
    },
    ...mapMutations([
      "setUserInfo",
      "setInitUserInfo",
      "confirmLogout",
      "setInitActiveInfo",
      "changeLoginPopup",
      "changeOsPopup"
    ]),
    ...mapActions(["onInitDataCallback", "setShare"])
  }
};
</script>

<style lang="less" scoped>
@import url("./index.less");
</style>



// WEBPACK FOOTER //
// src/pages/tideng/third/index/index.vue